import { render } from "./Albums.vue?vue&type=template&id=061ecd8c"
import script from "./Albums.vue?vue&type=script&lang=js"
export * from "./Albums.vue?vue&type=script&lang=js"

import exportComponent from "/Users/michellmonroy/Documents/dev-glider/catalogue-api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__